import { Aviso } from '../componentes/ui';
import { ErroApi, mensagemDoErro } from '../servicos/erros';

/**
 * Erro da API na tela: a mensagem do servidor e, se houver, os problemas por
 * campo que ainda não estão visíveis em algum input.
 *
 * ## Por que isto não virou componente da biblioteca de UI
 *
 * Ele conhece `ErroApi` e o contrato `{ message, erros: [{ campo, mensagem }] }`
 * do backend — é **tradução de erro em texto**, que é serviço, não superfície.
 * `componentes/ui` é apresentação pura e não importa `servicos/`. A superfície
 * daqui é toda emprestada: o `Aviso` oficial faz o desenho.
 *
 * ## O que ele preserva
 *
 * A mensagem exibida é sempre a que o backend mandou. Nunca um texto fixo: o
 * legado respondia "Assessor já cadastrado!" fosse qual fosse a falha, e quem
 * operava não tinha como saber o que corrigir (dívida técnica #50, RN-627,
 * RN-628).
 */
export function ErroDaApi(props: {
  readonly titulo?: string;
  readonly erro: unknown;
  /**
   * Campos que já mostram a própria mensagem embaixo do input. Repetir o mesmo
   * erro no topo e no campo treina o usuário a ignorar os dois.
   */
  readonly camposNoFormulario?: readonly string[];
}): JSX.Element {
  const noFormulario = props.camposNoFormulario ?? [];
  const detalhes =
    props.erro instanceof ErroApi
      ? props.erro.erros.filter((detalhe) => !noFormulario.includes(detalhe.campo))
      : [];

  return (
    <Aviso tom="erro" titulo={props.titulo ?? 'A operação não foi concluída'}>
      <p>{mensagemDoErro(props.erro)}</p>
      {detalhes.length > 0 && (
        <ul className="mt-2 list-inside list-disc space-y-1">
          {detalhes.map((detalhe) => (
            <li key={`${detalhe.campo}:${detalhe.mensagem}`}>
              <span className="valor-fiscal text-xs">{detalhe.campo}</span> — {detalhe.mensagem}
            </li>
          ))}
        </ul>
      )}
    </Aviso>
  );
}
